import * as React from 'react';
import * as _ from 'lodash';

import './star-rating.css';

interface IProps {
    numberOfStars: number,
    currentRating: number,
    onClick: (rating: number) => void
}

interface IState {
    currentRating: number
}

class StarRating extends React.Component<IProps, IState> {
    readonly state: IState = {
        currentRating: this.props.currentRating
    }

    refs: any;

    componentDidMount() {
        this.setRating(null);
    }

    hoverHandler = ev => {
        let stars = ev.target.parentElement.getElementsByClassName('star') as HTMLCollectionOf<HTMLElement>;
        let hoverValue = ev.target.dataset.value;

        Array.from(stars).forEach(star => {
            star.style.color = hoverValue >= star.dataset.value ? 'darkblue' : 'gray';
        });
    };

    setRating = ev => {
        let stars = this.refs.rating.getElementsByClassName('star') as HTMLCollectionOf<HTMLElement>;

        Array.from(stars).forEach(star => {
            star.style.color =
                this.state.currentRating >= parseInt(star.dataset.value) ? 'darkblue' : 'gray';
        });
    };

    starClickHandler = ev => {
        let rating = ev.target.dataset.value;

        this.setState({ currentRating: rating }); // set state so the rating stays highlighted

        this.props.onClick(rating); // emit the event up to the parent
    };

    render() {
        const keys = _.range(0, this.props.numberOfStars);

        return (
            <div
                className="rating"
                ref="rating"
                data-rating={this.state.currentRating}
                onMouseOut={this.setRating}
            >
                {keys.map(n => {
                    return (
                        <span
                            className="star"
                            key={n + 1}
                            data-value={n + 1}
                            onMouseOver={this.hoverHandler}
                            onClick={this.starClickHandler}
                        >
                            &#9733;
                        </span>
                    );
                })}
            </div>
        );
    }
}

export default StarRating;